import React from "react";
import { noop } from "lodash";
import { isTvg5 } from "@tvg/utils/generalUtils";

import SuccessHeaderRegistrationMolecule from "../../_molecule/SuccessHeaderRegistration";
import buildColor from "../../_static/ColorPalette";
import {
  OuterContainer,
  Background,
  ImageRain,
  BodyContainer,
  ButtonsContainer,
  InnerContainer,
  InnerTitle,
  InnerList,
  ListItemComplete,
  ListItem,
  IconContainer,
  LogoWrapper
} from "./styled-components";

import { successDouble } from "../../_static/Icons/iconsDuotone";
import { SuccessSymbol } from "../../_atom/SuccessSymbol";
import rmaBackgroundBlue from "../../_static/images/rma-blue-texture.png";
import rmaBackgroundGreen from "../../_static/images/rma-green-texture.png";
import ButtonLink from "../../_atom/Buttons/buttonLink";
import Icon from "../../_static/Icons";
import Logo from "../../_static/Logos";

export const SuccessRegistration = (props) => {
  const {
    device,
    brand,
    headerTitle,
    headerDescription,
    innerList,
    innerTitle,
    hasPromo,
    hasRaf,
    buttonPrimaryURL,
    buttonSecondaryURL,
    buttonPrimaryLabel,
    buttonSecondaryLabel,
    buttonSecondaryType,
    handleButtonSecondary,
    onButtonClickGtmEvent,
    gtmModule
  } = props;

  let symbolType = "default";

  if (hasPromo) {
    symbolType = "promo";
  }
  if (hasRaf) {
    symbolType = "raf";
  }

  const hasInnerList = !!(innerList && innerList.length);

  return (
    <OuterContainer>
      <Background hasPromo={hasPromo}>
        <ImageRain
          src={hasPromo ? rmaBackgroundGreen : rmaBackgroundBlue}
          alt="registration background"
        />
      </Background>
      <LogoWrapper>
        <Logo
          brand={brand}
          height={device === "mobile" ? 20 : 25}
          data-qa-label="tvg-logo"
        />
      </LogoWrapper>

      <BodyContainer>
        <SuccessSymbol type={symbolType} />
        <SuccessHeaderRegistrationMolecule
          title={headerTitle}
          description={headerDescription}
        />
        {hasInnerList && (
          <InnerContainer>
            <InnerTitle data-qa-label="success-inner-title">
              {innerTitle}
            </InnerTitle>
            <InnerList>
              <ListItemComplete>
                <IconContainer>
                  <Icon
                    icon={successDouble}
                    viewBoxSize={16}
                    color={buildColor("green", "100")}
                  />
                </IconContainer>
                Complete registration
              </ListItemComplete>
              {innerList.map((item, index) => (
                <ListItem
                  key={item}
                  data-qa-label={`success-inner-item-${index}`}
                >
                  {item}
                </ListItem>
              ))}
            </InnerList>
            <ButtonLink
              qaLabel="success-innerlist-primary-link"
              isUppercase={false}
              url={buttonPrimaryURL}
              type="primary"
              size="bigger"
              hasRoundedCorners
              tag="a"
              onClick={() =>
                onButtonClickGtmEvent(buttonPrimaryLabel, gtmModule)
              }
            >
              {buttonPrimaryLabel}
            </ButtonLink>
          </InnerContainer>
        )}
        <ButtonsContainer innerList={hasInnerList}>
          {!hasInnerList ? (
            <ButtonLink
              qaLabel="success-no-innerlist-primary-link"
              isUppercase={false}
              url={buttonPrimaryURL}
              type="primary"
              size="bigger"
              hasRoundedCorners
              tag={isTvg5() ? "link" : "a"}
              onClick={() =>
                onButtonClickGtmEvent(buttonPrimaryLabel, gtmModule)
              }
            >
              {buttonPrimaryLabel}
            </ButtonLink>
          ) : null}
          <ButtonLink
            qaLabel="success-secondary-link"
            isUppercase={false}
            type="tertiary_alt"
            size="bigger"
            tag={buttonSecondaryType}
            url={buttonSecondaryURL}
            onClick={handleButtonSecondary}
          >
            {buttonSecondaryLabel}
          </ButtonLink>
        </ButtonsContainer>
      </BodyContainer>
    </OuterContainer>
  );
};

SuccessRegistration.defaultProps = {
  device: "mobile",
  brand: "tvg",
  headerTitle: "",
  headerDescription: "",
  innerTitle: "",
  infoText: "",
  hasPromo: false,
  promocode: "",
  rafText: "",
  innerList: [],
  hasRaf: false,
  buttonPrimaryURL: "",
  buttonSecondaryURL: "",
  buttonSecondaryType: "a",
  handleButtonSecondary: noop,
  buttonPrimaryLabel: "",
  buttonSecondaryLabel: ""
};

export default SuccessRegistration;
